import React from 'react';
import { Link } from "react-router-dom";
import Layout from '../../layout/fullpage';

function NotFound() {
  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem 1rem',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #e4efe9 100%)',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
  };

  const contentStyle = {
    maxWidth: '600px',
    textAlign: 'center',
    position: 'relative',
    zIndex: 2,
  };

  const imageStyle = {
    maxWidth: '100%',
    height: '200px',
    filter: 'drop-shadow(0 25px 25px rgba(0, 0, 0, 0.15))',
  };

  const buttonStyle = {
    transition: 'all 0.3s ease-in-out',
    transform: 'translateY(0)',
    boxShadow: '0 10px 20px rgba(66, 153, 225, 0.3)',
    background: 'linear-gradient(90deg, #e18442ff 0%, #66686aff 100%)',
    border: 'none',
    borderRadius: '50px',
    padding: '1rem 2rem',
    fontSize: '1.1rem',
    fontWeight: '600',
    color: 'white',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    marginTop: '1rem',
  };

  return (
    <Layout title="Not Found" mask="2" centered>
      <div style={containerStyle}>
        {/* Decorative elements */}
        <div style={{
          position: 'absolute',
          top: '-5%',
          right: '-5%',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(66, 153, 225, 0.1) 0%, rgba(66, 153, 225, 0.05) 100%)',
          zIndex: 1,
        }}></div>
        
        <div style={{
          position: 'absolute',
          bottom: '-5%',
          left: '-5%',
          width: '250px',
          height: '250px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(66, 153, 225, 0.1) 0%, rgba(66, 153, 225, 0.05) 100%)',
          zIndex: 1,
        }}></div>
        
        <div style={contentStyle}>
          <div style={{
            marginBottom: '2rem',
            animation: 'float 6s ease-in-out infinite',
          }}>
            <img 
              src="https://i.imgur.com/lKJiT77.png" 
              alt="404 Illustration" 
              style={imageStyle}
            />
          </div>
          
          <h1 style={{
            fontSize: '5rem',
            fontWeight: '800',
            color: '#2D3748',
            margin: '0 0 0.5rem 0',
            background: 'linear-gradient(135deg, #ed793aff 0%, #f2f5f7ff 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            404
          </h1>
          
          <h2 style={{
            fontSize: '1.75rem',
            fontWeight: '600',
            color: '#4A5568',
            margin: '0 0 1.5rem 0',
          }}>
            Oops! Page not found
          </h2>
          
          {/* <p style={{
            fontSize: '1.1rem',
            color: '#718096',
            lineHeight: '1.6',
            marginBottom: '2.5rem',
          }}>
            The page you are looking for might have been removed, had its name changed, 
            or is temporarily unavailable.
          </p> */}
          
          <Link 
            to="/" 
            style={buttonStyle}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 15px 25px rgba(66, 153, 225, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 10px 20px rgba(66, 153, 225, 0.3)';
            }}
          >
            <span style={{ marginRight: '0.5rem' }}>←</span>
            Return to Homepage
          </Link>
        </div>
      </div>
      
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
          100% { transform: translateY(0px); }
        }
        
        @media (max-width: 640px) {
          h1 {
            font-size: 3.5rem !important;
          }
          
          h2 {
            font-size: 1.5rem !important;
          }
        }
      `}</style>
    </Layout>
  );
}

export default NotFound;